module.exports = __webpack_public_path__ + "img/artilleryLeft.122bb648.svg";